import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import BackButton from 'component/button/Back'
import SubmitButton from 'component/button/Submit'
import { FormSwitch } from 'component/forms'
import {
  FormInputName,
  FormInputUrutan,
  FormSelectSection,
  FormSelectPrecontent,
  FormInputTanggal,
  FormSelectAssignment,
  FormActiveStatus,
  FormActiveKey,
  FormSelectFeedback,
  FormGroupKecil,
  FormInputDesc,
  FormInputEndedAt,
  FormTextArea,
  FormStatusKomentarTugas,
  FormCheckTypeRapor,
  FormSelectStudent,
} from 'component/content-form'

export default function AddContentAssignment() {
  /* ========================================== Helpers ========================================= */
  const history  = useHistory()
  const location = useLocation()
  const params = useParams()

  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest } = useBaseContext()

  /* =========================================== Refs =========================================== */
  const isMounted = useRef(true)

  /* ========================================= Constants ======================================== */
  const links = [
    { url: '/kelas', name: 'Sub Mata Pelajaran' },
    { url: `/kelas/${location.state.kelasId}`, name: 'Overview' },
  ]
  const contentType = 8
  const sections    = location.state.sectionList ? location.state.sectionList : []

  /* ======================================= Local States ======================================= */
  const [existingContents, setExistingContents] = useState([])
  const [assignList, setAssignList]             = useState([])
  const [namaKonten, setNamaKonten]             = useState('')
  const [urutan, setUrutan]                     = useState('')
  const [sectionId, setSectionId]               = useState('')
  const [preContentId, setPrecontentId]         = useState('')
  const [active, setActive]                     = useState(0)
  const [displayAt, setDisplayAt]               = useState('')
  const [assignmentId, setAssignmentId]         = useState(null)
  const [feeds, setFeeds]                       = useState([])
  const [feedId, setFeedId]                     = useState(null)
  const [isFeedActive, setIsFeedActive]         = useState(0)
  const [enableGroup, setEnableGroup]           = useState(false)
  const [maxGroup, setMaxGroup]                 = useState('')
  const [descGroup, setDescGroup]               = useState('')
  const [endedAt, setEndedAt]                   = useState('')
  const [description, setDescription]           = useState('')
  const [apresiasi, setApresiasi]               = useState('')
  const [komentarTugas, setKomentarTugas]       = useState(1)
  const [rating, setRating]                     = useState(1)
  const [isPengetahuan, setIsPengetahuan]       = useState(false)
  const [isKeterampilan, setIsKeterampilan]     = useState(false)
  const [selectedStudents, setSelectedStudents] = useState([])

  const [enableGroupKey, setEnableGroupKey] = useState(false)
  const [prerequisite, setPrerequisite]     = useState('')

  const [isNamaInvalid, setIsNamaInvalid]       = useState(false)
  const [isUrutanInvalid, setIsUrutanInvalid]   = useState(false)
  const [isSectionInvalid, setIsSectionInvalid] = useState(false)
  const [isAssignInvalid, setIsAssignInvalid]   = useState(false)
  const [isMaxGroupValid, setIsMaxGroupValid]   = useState(true)
  const [loadingSubmit, setLoadingSubmit]       = useState(false)

  /* =========================================== Refs =========================================== */
  const refInputName     = useRef()
  const refSelectSection = useRef()
  const refInputUrutan   = useRef()
  const refSelectAssign  = useRef()
  const refMaxGroup      = useRef()

  /* ========================================= Functions ======================================== */
  function getExistingContentsBySelectedSection() {
    if (!sectionId) {
      if (isMounted.current) {
        setExistingContents([])
      }
    } else {
      sections.forEach((section) => {
        if (section.id === sectionId) {
          if (isMounted.current) {
            setExistingContents(section.contents)
          }
        }
      })
    }
  }

  async function getAssignmentList() {
    const response = await getRequest('assignment?isTitleOnly=true')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.title,
      }))
      if (isMounted.current) {
        setAssignList(options)
      }
    }
  }

  async function getFeedsList() {
    const response = await getRequest('feed')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.description,
      }))
      if (isMounted.current) {
        setFeeds(options)
      }
    }
  }

  function handleChangeName(event) {
    setNamaKonten(event.target.value)
  }

  function handleChangeUrutan(event) {
    setUrutan(Math.abs(event.target.value))
  }

  function handleChangeSection(event) {
    setSectionId(event.target.value)
  }

  function handleChangePrecontent(event) {
    setPrecontentId(event.target.value)
  }

  function handleChangeDate(event) {
    setDisplayAt(event.target.value)
  }

  function handleChangeActive() {
    if (active === 1) {
      setActive(0)
    }
    if (active === 0) {
      setActive(1)
    }
  }

  function handleChangeAssignment(val) {
    setAssignmentId(val)
  }

  function handleChangeFeedback(val) {
    setFeedId(val)
  }

  function handleChangeEnableGroup() {
    if (enableGroup) {
      setEnableGroup(false)
      setMaxGroup('')
      setIsMaxGroupValid(true)
    } else {
      setEnableGroup(true)
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeMaxGroup(event) {
    if (event.target.value) {
      const absolute = Math.abs(event.target.value)
      const integer = Math.round(absolute)
      setMaxGroup(integer)
      if (integer <= 0) {
        setIsMaxGroupValid(false)
      } else {
        setIsMaxGroupValid(true)
      }
    } else {
      setMaxGroup('')
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeEnableGroupKey() {
    if (enableGroupKey) {
      setEnableGroupKey(false)
    } else {
      setEnableGroupKey(true)
    }
  }

  function handleChangeDescGroup(event) {
    setDescGroup(event.target.value)
  }

  function handleChangeDesc(event) {
    setDescription(event.target.value)
  }

  function handleChangeEndedAt(event) {
    setEndedAt(event.target.value)
  }

  function handleChangeApresiasi(event) {
    setApresiasi(event.target.value)
  }

  function handleChangeKomentarTugas() {
    if (komentarTugas === 1) {
      setKomentarTugas(0)
    }
    if (komentarTugas === 0) {
      setKomentarTugas(1)
    }
  }

  function handleChangeRating(value) {
    setRating(value ? 1 : 0)
  }

  function handleChangeIsPengetahuan(event) {
    setIsPengetahuan(event.target.checked)
  }

  function handleChangeIsKeterampilan(event) {
    setIsKeterampilan(event.target.checked)
  }

  function handleFormValidation() {
    const feedback = isFeedActive === 1 ? feedId : ''

    if (namaKonten && urutan && sectionId && assignmentId && isMaxGroupValid) {
      setIsNamaInvalid(false)
      setIsSectionInvalid(false)
      setIsUrutanInvalid(false)
      setIsAssignInvalid(false)
      handleFormSubmit(
        namaKonten,
        contentType,
        sectionId,
        urutan,
        active,
        displayAt,
        preContentId,
        assignmentId.value,
        feedback.value,
        maxGroup,
        descGroup,
        endedAt,
        description,
        apresiasi,
        komentarTugas,
        rating,
        isPengetahuan,
        isKeterampilan,
      )
    } else {
      if (!isMaxGroupValid) {
        if (refMaxGroup) {
          refMaxGroup.current.focus()
        }
      }

      if (!sectionId) {
        setIsSectionInvalid(true)
        refSelectSection.current.focus()
      } else {
        setIsSectionInvalid(false)
      }

      if (!urutan) {
        setIsUrutanInvalid(true)
        refInputUrutan.current.focus()
      } else {
        setIsUrutanInvalid(false)
      }

      if (!assignmentId) {
        setIsAssignInvalid(true)
        refSelectAssign.current.focus()
      } else {
        setIsAssignInvalid(false)
      }

      if (!namaKonten) {
        setIsNamaInvalid(true)
        refInputName.current.focus()
      } else {
        setIsNamaInvalid(false)
      }

      window.notification('Mohon', 'lengkapi data')
    }
  }

  async function handleFormSubmit(
    namaKonten,
    contentType,
    sectionId,
    urutan,
    active,
    displayAt,
    preContentId,
    contentsUrl,
    feedId,
    maxGroup,
    descGroup,
    endedAt,
    description,
    apresiasi,
    komentarTugas,
    rating,
    isPengetahuan,
    isKeterampilan,
  ) {
    let form = new FormData()
    form.append('title', namaKonten)
    form.append('content_type', contentType)
    form.append('section_id', sectionId)
    form.append('urutan', urutan)
    form.append('active', active)
    form.append('contents_url', contentsUrl)
    form.append('komentar_tugas', komentarTugas)
    form.append('rating', rating)
    form.append('is_pengetahuan', isPengetahuan)
    form.append('is_keterampilan', isKeterampilan)

    if (Array.isArray(selectedStudents) && !!selectedStudents.length) {
      selectedStudents.forEach((selectedStudent, selectedStudentIndex) => {
        form.append(`spesifik_user_id[${selectedStudentIndex}]`, selectedStudent.id)
      })
    }

    if (displayAt) {
      form.append('display_at', displayAt)
    }

    if (endedAt) {
      form.append('ended_at', endedAt)
    }

    if (description) {
      form.append('deskripsi', description)
    }

    if (preContentId) {
      form.append('precontent_id', preContentId)
    }

    if (feedId) {
      form.append('feedback', feedId)
    }

    if (enableGroup) {
      form.append('group_status', 1)
      if (maxGroup) {
        form.append('group_max', maxGroup)
      }
      if (descGroup) {
        form.append('group_description', descGroup)
      }
    }

    if (apresiasi) {
      form.append('apresiasi', apresiasi)
    }

    setLoadingSubmit(true)

    const response = await postRequest('contents', form)
    if (response) {
      if (enableGroupKey) {
        let formkey = new FormData()
        formkey.append('description', prerequisite)
        formkey.append('content_id', response.data.id)

        const response1 = await postRequest('contentTakeAway', formkey)
        if (response1) {
          window.notification('Materi', 'berhasil ditambahkan', 'success')
          history.goBack()
        }
      } else {
        window.notification('Materi', 'berhasil ditambahkan', 'success')
        history.goBack()
      }
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getExistingContentsBySelectedSection()
  }, [sectionId])

  useEffect(() => {
    getAssignmentList()
    getFeedsList()

    return () => {
      isMounted.current = false
    }
  }, [])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header pageName="Tambah Tugas" linkName="Tugas" links={links} />
        
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                <h5>
                  <i className="fas fa-pen-alt mr-1" />
                  Informasi Tugas
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <form>
                      {/* Input Nama Konten */}
                      <FormInputName
                        label="Nama Tugas"
                        placeholder="Nama Tugas"
                        namaKonten={namaKonten}
                        handleChangeName={handleChangeName}
                        isNamaInvalid={isNamaInvalid}
                        refInputName={refInputName}
                      />

                      {/* Select Assignment */}
                      <FormSelectAssignment
                        assignmentList={assignList}
                        handleChangeAssignment={handleChangeAssignment}
                        existingAssignmentId={assignmentId}
                        isAssignmentInvalid={isAssignInvalid}
                        refSelectAssignment={refSelectAssign}
                        getAssignmentList={getAssignmentList}
                      />

                      <FormCheckTypeRapor
                        handleChangeIsPengetahuan={handleChangeIsPengetahuan}
                        handleChangeIsKeterampilan={
                          handleChangeIsKeterampilan
                        }
                        isPengetahuan={isPengetahuan}
                        isKeterampilan={isKeterampilan}
                      />

                      {/* Komentar Tugas */}
                      <FormStatusKomentarTugas
                        status={komentarTugas}
                        handleChange={handleChangeKomentarTugas}
                      />

                      {/* Input Urutan */}
                      <FormInputUrutan
                        urutan={urutan}
                        handleChangeUrutan={handleChangeUrutan}
                        isUrutanInvalid={isUrutanInvalid}
                        refInputUrutan={refInputUrutan}
                      />

                      {/* Input deskripsi */}
                      <FormInputDesc
                        description={description}
                        handleChangeDesc={handleChangeDesc}
                      />

                      {/* Input Apresiasi */}
                      <FormTextArea
                        id="formInputApresiasi"
                        label="Apresiasi"
                        placeholder="Apresiasi/pesan setelah siswa menyelesaikan materi (opsional)"
                        className="mb-5"
                        value={apresiasi}
                        handleChange={handleChangeApresiasi}
                      />

                      {/* Select Section */}
                      <FormSelectSection
                        sections={sections}
                        handleChangeSection={handleChangeSection}
                        isSectionInvalid={isSectionInvalid}
                        refSelectSection={refSelectSection}
                      />

                      {/* Select Precontent */}
                      <FormSelectPrecontent
                        existingContents={existingContents}
                        handleChangePrecontent={handleChangePrecontent}
                      />

                      {/* Input Tanggal Ditampilkan */}
                      <FormInputTanggal
                        existingDisplayAt={displayAt}
                        handleChangeDate={handleChangeDate}
                      />

                      {/* Input ended at */}
                      <FormInputEndedAt
                        endedAt={endedAt}
                        handleChangeEndedAt={handleChangeEndedAt}
                      />

                      {/* Rating */}
                      <FormSwitch
                        id="formRating"
                        label="Rating Materi"
                        value={rating}
                        handleChange={handleChangeRating}
                      />

                      {/* Select feedback */}
                      <FormSelectFeedback
                        existingFeeds={feeds}
                        existingFeedId={feedId}
                        isFeedActive={isFeedActive}
                        setIsFeedActive={setIsFeedActive}
                        handleChangeFeeds={handleChangeFeedback}
                        getFeedList={getFeedsList}
                      />

                      {/* Swicth Group Kecil */}
                      <FormGroupKecil
                        enableGroup={enableGroup}
                        handleChangeEnableGroup={handleChangeEnableGroup}
                        maxGroup={maxGroup}
                        descGroup={descGroup}
                        handleChangeMaxGroup={handleChangeMaxGroup}
                        handleChangeDescGroup={handleChangeDescGroup}
                        isMaxGroupValid={isMaxGroupValid}
                        refMaxGroup={refMaxGroup}
                      />

                      {/* Select Specific Students */}
                      <FormSelectStudent 
                        selectedStudents={selectedStudents}
                        setSelectedStudents={setSelectedStudents}
                        subMapelId={params?.kelasId}
                        isWithCheckSavedOrNot={false}
                      />

                      {/* Select Status */}
                      <FormActiveStatus
                        existingStatus={active}
                        handleChangeStatus={handleChangeActive}
                      />

                      <FormActiveKey
                        enableGroupKey={enableGroupKey}
                        handleChangeEnableGroupKey={
                          handleChangeEnableGroupKey
                        }
                        prerequisite={prerequisite}
                        setPrerequisite={setPrerequisite}
                      />

                      <div className="form-group">
                        <BackButton />
                        {loadingSubmit ? (
                          <button
                            disabled={true}
                            type="button"
                            className="btn btn-success mr-2"
                          >
                            <span
                              className="spinner-border spinner-border-sm mr-1"
                              role="status"
                            />
                            <span>Simpan</span>
                          </button>
                        ) : (
                          <SubmitButton
                            onClick={() => handleFormValidation()}
                            text="Simpan"
                          />
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
